import {
	BookOpen,
	CircleCheckBig,
	CookingPot,
	House,
	MapPinned,
	ShoppingBasket,
	type LucideIcon,
} from 'lucide-react'
import { Link, useRouter } from '@router'
import styles from './TabBar.module.css'

type Tab = {
	href: string
	label: string
	Icon: LucideIcon
}

// Curated bottom-bar destinations — a subset of APPS plus Home. Order is
// intentional (Home first, then the apps we surface natively).
const TABS: readonly Tab[] = [
	{ href: '/', label: 'Home', Icon: House },
	{ href: '/recipes', label: 'Recipes', Icon: BookOpen },
	{ href: '/meals', label: 'Meals', Icon: CookingPot },
	{ href: '/groceries', label: 'Groceries', Icon: ShoppingBasket },
	{ href: '/todo', label: 'Todo', Icon: CircleCheckBig },
	{ href: '/activities', label: 'Activities', Icon: MapPinned },
]

// Home matches only the exact root; every other tab owns its first path
// segment, so /recipes/123 and /activities/map still light up the right
// tab.
const isActive = (path: string, href: string): boolean => {
	if (href === '/') return path === '/' || path === ''
	const seg = path.replace(/^\//, '').split('/')[0]
	return seg === href.replace(/^\//, '')
}

export const TabBar = () => {
	const { path } = useRouter()

	return (
		<nav className={styles.bar} aria-label="Main">
			{TABS.map(({ href, label, Icon }) => {
				const active = isActive(path, href)
				return (
					<Link
						key={href}
						href={href}
						className={styles.tab}
						aria-current={active ? 'page' : undefined}
					>
						<Icon
							className={styles.icon}
							size={22}
							strokeWidth={active ? 2.4 : 2}
							aria-hidden="true"
						/>
						<span className={styles.label}>{label}</span>
					</Link>
				)
			})}
		</nav>
	)
}
